// Copyright 2023 Immersive Technologies Pty Ltd. All rights reserved.

export const emailFormatValidation =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@\[?[a-zA-Z0-9-:]+(?:\.[a-zA-Z0-9-]+)*\]?$/i;
